import React from 'react';
import uniqid from 'uniqid';
import ValidationControl from '../ValidationControl/ValidationControl';
import TextArea from './TextArea';

export interface IProps {
  name: string;
  value: string;
  dataType?: string;
  onChange?: (event: any) => void;
  isReadonly: boolean;
  rows?: number;
  isRequired?: boolean;
  isValid?: boolean;
  validationMessage?: string;
  height?: string;
  style?: {};
  hideValidationControl?: boolean;
}

export const TextAreaControlObject: React.FC<IProps> = (props) => {
  const uid = uniqid();

  return (
    <table>
      <tbody>
        <tr>
          {!props.hideValidationControl && (
            <td style={{ verticalAlign: 'top' }}>
              <ValidationControl
                {...props}
                isValid={props.isValid !== undefined ? props.isValid : true}
                message={props.validationMessage ? props.validationMessage : 'An input is required'}
                uid={uid}
              />
            </td>
          )}
          <td>
            <TextArea {...props} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TextAreaControlObject;
